import { __classPrivateFieldSet, __classPrivateFieldGet } from '../../../../../node_modules/tslib/tslib.es6.js';
import { ExtensionIdentifier } from 'monaco-editor/esm/vs/platform/extensions/common/extensions.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
var _ExtensionSecrets_secretState;
class ExtensionSecrets {
    constructor(extensionDescription, secretState) {
        _ExtensionSecrets_secretState.set(this, void 0);
        this._onDidChange = ( new Emitter());
        this.onDidChange = this._onDidChange.event;
        this._id = ExtensionIdentifier.toKey(extensionDescription.identifier);
        __classPrivateFieldSet(this, _ExtensionSecrets_secretState, secretState, "f");
        __classPrivateFieldGet(this, _ExtensionSecrets_secretState, "f").onDidChangePassword(e => {
            if (e.extensionId === this._id) {
                this._onDidChange.fire({ key: e.key });
            }
        });
    }
    get(key) {
        return __classPrivateFieldGet(this, _ExtensionSecrets_secretState, "f").get(this._id, key);
    }
    store(key, value) {
        return __classPrivateFieldGet(this, _ExtensionSecrets_secretState, "f").store(this._id, key, value);
    }
    delete(key) {
        return __classPrivateFieldGet(this, _ExtensionSecrets_secretState, "f").delete(this._id, key);
    }
}
_ExtensionSecrets_secretState = ( new WeakMap());
export { ExtensionSecrets };
